var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 7.16634L1.91634 11.2497C1.76356 11.4025 1.56912 11.4788 1.33301 11.4788C1.0969 11.4788 0.902452 11.4025 0.749674 11.2497C0.596897 11.0969 0.520508 10.9025 0.520508 10.6663C0.520508 10.4302 0.596897 10.2358 0.749674 10.083L4.83301 5.99967L0.749674 1.91634C0.596897 1.76356 0.520508 1.56912 0.520508 1.33301C0.520508 1.0969 0.596897 0.902452 0.749674 0.749674C0.902452 0.596897 1.0969 0.520508 1.33301 0.520508C1.56912 0.520508 1.76356 0.596897 1.91634 0.749674L5.99967 4.83301L10.083 0.749674C10.2358 0.596897 10.4302 0.520508 10.6663 0.520508C10.9025 0.520508 11.0969 0.596897 11.2497 0.749674C11.4025 0.902452 11.4788 1.0969 11.4788 1.33301C11.4788 1.56912 11.4025 1.76356 11.2497 1.91634L7.16634 5.99967L11.2497 10.083C11.4025 10.2358 11.4788 10.4302 11.4788 10.6663C11.4788 10.9025 11.4025 11.0969 11.2497 11.2497C11.0969 11.4025 10.9025 11.4788 10.6663 11.4788C10.4302 11.4788 10.2358 11.4025 10.083 11.2497L5.99967 7.16634Z",
    fill: "#837F39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cbb83bacbfc0e8168c840b1330e5bcd4.svg";
export { ForwardRef as ReactComponent };